module.exports = __webpack_public_path__ + "assets/fonts/Krug-Hand.de9261a8.otf";